<template>
  <button><slot /></button>
</template>

<style lang="scss" scoped>
$primary-color: #949494;
$warning-color: #8d3939;
$secondary-color: #375470;

button {
  background-color: $primary-color;
  border-radius: 5px;
  border: 1px solid #6d7479;
  box-shadow: 1px 1px 0 #fff;
  color: #fff;
  cursor: pointer;
  display: inline-block;
  font-family: 'Open Sans Condensed', sans-serif;
  font-size: 1.25rem;
  font-weight: bold;
  height: 45px;
  padding: 0 15px;
  text-shadow: 0px 0px 1px #555a5e;
  outline: 0;
  white-space: nowrap;

  &:hover {
    background: darken($primary-color, 5%);
  }

  &:active {
    background: darken($primary-color, 10%);
    padding: 6px 15px 4px;
  }

  &:focus {
    background: darken($primary-color, 10%);
  }

  &.warning {
    background-color: $warning-color;

    &:hover {
      background-color: darken($warning-color, 5%);
    }
  }

  &.secondary {
    background-color: $secondary-color;

    &:hover {
      background-color: darken($secondary-color, 5%);
    }
  }

  &:disabled {
    opacity: 0.5;
  }
}
</style>
